/**
 * Removes all falsey values (null, undefined, false, 0, '', NaN) from an object.
 * @param {Record<string, unknown> | undefined} obj - The source object to filter
 * @returns {Record<string, unknown>} A new object containing only truthy values
 */
export function excludeFalseyValues(
  obj: Record<string, unknown> | undefined,
): Record<string, unknown> {
  return Object.fromEntries(Object.entries(obj || {}).filter(([_, value]) => value))
}

// These are the values we consider "empty"
const emptyValues = [null, undefined, '', NaN]
/**
 * Removes all null-ish 'empty' values (null, undefined, 0, '', NaN) from an object.
 * Note: This might be what we want to use most or all places excludeFalseyValues, since
 * an explicit false or 0 is often meaningful data that needs to be passed on.
 * @param {Record<string, unknown> | undefined} obj - The source object to filter
 * @returns {Record<string, unknown>} A new object containing only truthy values
 */
export function excludeEmptyValues(
  obj: Record<string, unknown> | undefined,
): Record<string, unknown> {
  return Object.fromEntries(
    Object.entries(obj || {}).filter(([_, value]) => !emptyValues.includes(value)),
  )
}
